import { environment } from './../../environments/environment';
import { of } from 'rxjs';
import { UtilsService } from './utils.service';
import * as i0 from "@angular/core";
import * as i1 from "./utils.service";
var ResponsibleService = /** @class */ (function () {
    function ResponsibleService(_utilsService) {
        this._utilsService = _utilsService;
    }
    ResponsibleService.prototype.voluntaryExclusion = function (user_id, length, password) {
        password = btoa(password); //base64 encode
        return this._utilsService.postRequest(environment.phpApiUrl + "/users/exclusion", { user_id: user_id, length: length, password: password }, null, 'content-type-json');
    };
    ResponsibleService.prototype.depositLimit = function (user_id, amount, length, password) {
        password = btoa(password); //base64 encode
        return this._utilsService.postRequest(environment.phpApiUrl + "/users/depositLimit", { user_id: user_id, amount: amount, length: length, password: password }, null, 'content-type-json');
    };
    ResponsibleService.prototype.handleErrorPost = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            console.error(result); // log to console instead 
            // TODO: better job of transforming error for user consumption
            console.log(operation + " failed: " + error.message);
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    ResponsibleService.ngInjectableDef = i0.defineInjectable({ factory: function ResponsibleService_Factory() { return new ResponsibleService(i0.inject(i1.UtilsService)); }, token: ResponsibleService, providedIn: "root" });
    return ResponsibleService;
}());
export { ResponsibleService };
